export default __webpack_public_path__ + "static/media/logo-opera.69fec9dc.png";